import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomPage } from '../custom-page.types';
import { CorePageBaseComponent } from '@workflow/dynamic-render/page/shared/core-page-base.component';
import { StatefulService } from '@app/service/stateful.service';
import { PageInstance } from '@workflow/class/page.service';
import { FlowInstance } from '@workflow/class/flow.service';
import { CardInstance } from '@workflow/class/card.service';

@CustomPage('legacy-review')
@Component({
  selector: 'ecp-legacy-review-page',
  templateUrl: `legacy-review-page.component.html`,
  styleUrls: [],
  standalone: false
})
export class LegacyReviewPageComponent extends CorePageBaseComponent implements OnInit, OnDestroy {
  private readonly statefulService = inject(StatefulService);

  /** review page validity */
  public reviewPageValidity = false;
  public pageSubmitted = false;
  public subscription: Subscription;
  // eslint-disable-next-line max-len
  public message = `There was an issue with your submission. Please <a href="${location.href}">click here</a> to refresh your application. If the problem persists, please log out and log back in to try again.`;

  public updateReviewValidity(validity): void {
    if (validity) {
      this.reviewPageValidity = validity.valid;
    }
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.subscription = this.workflowPageNavigationService.pageSubmitted$.subscribe((t) => {
      this.pageSubmitted = t;
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  editUrlFn = (page: PageInstance, flow: FlowInstance, card: CardInstance) => {
    this.workflowPageNavigationService.navigateToPage(page, card?.id);
    if (flow.id.includes('oao')) {
      this.statefulService.wrap('mem:oaoReviewFragment').value = card?.id;
    } else {
      this.statefulService.wrap('mem:olaReviewFragment').value = card?.id;
    }
  };

  public showAlert(): boolean {
    return this.pageSubmitted && (!this.page.helper.isPageComplete || !this.flow.isCompleted);
  }
}
